import { render, staticRenderFns } from "./IPManagement.vue?vue&type=template&id=6570707f"
import script from "./IPManagement.vue?vue&type=script&lang=js"
export * from "./IPManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports